// Disposition commune : barre latérale de navigation, en-tête avec l'indicateur de
// synchronisation et la bascule « faible énergie », zone de page.
import { useState } from 'react';
import { NavLink, Outlet, Link } from 'react-router';
import { useMagasin, magasin } from '../donnees/magasin';
import { IndicateurSync } from './IndicateurSync';
import { jourPedagogique } from '@partage/dates';
import { fileDeRevision, sessionEnCours } from '@partage/programme';

export function Disposition() {
  const { etat, bundles, utilisateur, connecte } = useMagasin();
  const [menuOuvert, setMenuOuvert] = useState(false);
  const aujourdhui = jourPedagogique(new Date());
  const dues = fileDeRevision(etat, aujourdhui).length;
  const bundle = bundles[etat.saison_courante];
  const enCours = bundle ? sessionEnCours(etat, bundle) : undefined;
  const faibleEnergie = etat.parametres.faible_energie_defaut;

  const lien = (vers: string, texte: string, badge?: number) => (
    <NavLink to={vers} end={vers === '/'} className={({ isActive }) => (isActive ? 'actif' : '')} onClick={() => setMenuOuvert(false)}>
      {texte}{badge ? <span className="badge accent">{badge}</span> : null}
    </NavLink>
  );

  return (
    <div className="disposition">
      <nav className={`laterale ${menuOuvert ? 'ouverte' : ''}`} aria-label="Navigation principale">
        <div className="marque"><img src="/icones/icone-192.png" alt="" /> Formation</div>
        {lien('/', 'Tableau de bord')}
        {enCours ? lien(`/sessions/${enCours.id}`, `▶ ${enCours.id} en cours`) : null}
        {lien('/reviser', 'Réviser', dues)}
        {lien('/memo', 'Mémo')}
        {lien('/planning', 'Planning')}
        {lien('/tableau', etat.tableau.mode === 'scrum' ? 'Backlog et sprints' : 'Kanban')}
        {lien('/journal', 'Journal')}
        {lien('/portfolio', 'Portfolio')}
        {lien('/parcours', 'Parcours')}
        {lien('/veille', 'Veille marché')}
        {lien('/defis', 'Défis et soutenances')}
        <div className="bas">
          {lien('/parametres', 'Paramètres')}
          {lien('/aide', 'Aide')}
          <div className="petit-texte doux" style={{ padding: '0.6em 0.7em' }}>
            {utilisateur}<br />
            {connecte ? 'Connecté' : <Link to="/connexion">Se reconnecter</Link>}
          </div>
        </div>
      </nav>
      <div className="principal">
        <header className="entete">
          <button className="menu-mobile discret" aria-label="Menu" onClick={() => setMenuOuvert((o) => !o)}>☰</button>
          <h1>{bundle ? `Saison ${bundle.numero} · ${bundle.titre}` : 'Formation'}</h1>
          <span className="espace" />
          <button className={faibleEnergie ? 'petit principal' : 'petit'} title="Sessions de 20 min : cartes, lecture commentée, quiz (R-SES-10)" onClick={() => void magasin.emettre('parametres_modifies', { faible_energie_defaut: !faibleEnergie })}>
            {faibleEnergie ? '🔋 Faible énergie : activé' : '🔋 Faible énergie'}
          </button>
          <IndicateurSync />
        </header>
        <main className="page">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
